import { useSelector } from "react-redux";

export default function useAuth(role) {
    const auth = useSelector((state) => state.auth);

    if (auth?.accessToken && auth?.user && auth?.user.role === role) {
        return true;
    } else {
        return false;
    }
}